/**
 * Defaults para Diálogos y Modales
 */

export const dialogDefaults: Record<string, Record<string, unknown> | undefined> = {
  VDialog: {
    rounded: 'lg',
    maxWidth: '600px',
    VBtn: {
      variant: 'elevated',
      rounded: 'lg',
      style: [{ textTransform: 'none' }],
    },
  },

  VBottomSheet: {
    rounded: 'lg',
  },
}
